import {
  Box,
  styled,
} from '@mui/material';
import {
  chromeYellow,
  spaceCadet,
} from '../../../utils/colors';

const StyledToolBar = styled(Box)(({ theme }) => ({
  zIndex: theme.zIndex.modal + 2,
  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
  padding: '4px 12px',
  backgroundColor: spaceCadet[700],
  border: `solid ${chromeYellow[500]}`,
  borderWidth: '2px 0 0 0',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: 'white',
  height: 75,
  flexDirection: 'column',

  '& > .MuiBox-root': {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    padding: '0px 12px',
  },
}));

export default StyledToolBar;
